export default "__VITE_ASSET__D7GB6FmV__"